import type { FC, SVGProps } from 'react';

export const JiraLogo: FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
    {...props}
  >
    <defs>
      <linearGradient
        id="jira-a"
        x1="98.03%"
        x2="58.89%"
        y1="0.22%"
        y2="40.77%"
      >
        <stop offset="18%" stopColor="#0052CC" />
        <stop offset="100%" stopColor="#2684FF" />
      </linearGradient>
      <linearGradient
        id="jira-b"
        x1="100.17%"
        x2="55.35%"
        y1="0.05%"
        y2="44.72%"
      >
        <stop offset="18%" stopColor="#0052CC" />
        <stop offset="100%" stopColor="#2684FF" />
      </linearGradient>
    </defs>
    <path
      d="M244.66 0H121.72a55.5 55.5 0 0 0 55.5 55.5h22.59v21.81a55.5 55.5 0 0 0 55.5 55.5V11.34A11.34 11.34 0 0 0 244.66 0Z"
      fill="#2684FF"
    />
    <path
      d="M183.82 61.26H60.88a55.5 55.5 0 0 0 55.5 55.5h22.59v21.81a55.5 55.5 0 0 0 55.5 55.5V72.6a11.34 11.34 0 0 0-10.65-11.34Z"
      fill="url(#jira-a)"
    />
    <path
      d="M122.98 122.53H0a55.5 55.5 0 0 0 55.5 55.5h22.59v21.81a55.5 55.5 0 0 0 55.5 55.5V133.87a11.34 11.34 0 0 0-10.61-11.34Z"
      fill="url(#jira-b)"
    />
  </svg>
);
